import React from 'react'

export interface LayoutProps {
  title: string
  subtitle?: React.ReactNode
  children: any
  stickyTitle?: boolean
}

export const Layout: React.FC<LayoutProps> = (props) => {
  return (
    <main className="flex-1 relative focus:outline-none">
      <div className="pt-6">
        <div
          className={
            `mx-auto px-4 sm:px-6 md:px-8 py-4` +
            (props.stickyTitle
              ? " sticky top-0 bg-slate-100 dark:bg-slate-900 z-10"
              : "")
          }
        >
          <div className="text-2xl font-medium text-gray-900 dark:text-gray-100">{props.title}</div>
          {props.subtitle && <div className="mt-1">{props.subtitle}</div>}
        </div>
        <div className="mx-auto px-4 sm:px-6 md:px-8">{props.children}</div>
      </div>
    </main>
  )
}

export default Layout
